import { styled } from "sharedUI/styles";
import { BaseScreenStyle } from "../../../ui/views/base-screen/base-screen-style";

export const BillingScreenStyle = styled(BaseScreenStyle)`
    font-size: 14px;
    max-width: 1280px;

    & .bill-trans-appear {
        opacity: 0;
    }

    & .bill-trans-appear-active {
        opacity: 1;
        transition: opacity 200ms;
    }

    & .bill-header {
        display: flex;
        justify-content: space-between;

        font-weight: bold;
        font-size: 16px;
        margin-bottom: 20px;
    }

    & div.bill-header-grid {
        display: flex;
        justify-content: space-between;
        align-items: center;

        & .bill-header-menu {
            font-weight: normal;
            color: ${p => p.theme.fgColorMedium};
        }
    }

    & .bill-plan {
        font-weight: 600;
    }

    & .bill-line {
        height: 44px;
        display: flex;
        align-items: center;

        & em {
            font-weight: bold;
            font-style: normal;
        }

        & span.past-due {
            color: ${p => p.theme.errorColor};
        }

        > *:nth-last-child(2) {
            flex-grow: 1;
        }

        > *:not(:first-child) {
            margin-left: 10px;
        }

        border-bottom: 1px solid ${p => p.theme.borderColorLight};
    }

    & .bill-line-header {
        font-size: 12px;
        font-weight: bold;
        line-height: 13px;
        text-transform: uppercase;

        margin-bottom: 4px;

        color: ${p => p.theme.fgColorMedium};

        margin-top: 30px;
    }

    & .bill-total {
        height: 51px;
        align-items: flex-end;

        border-bottom: unset;

        & .bill-total-next-payment,
        & .bill-total-estimated-total {
            font-size: 14px;
            color: ${p => p.theme.fgColorMedium};
        }
        & .bill-total-estimated-total {
            & > .bill-total-estimated-total-price {
                font-weight: bold;
                font-size: 18px;
                color: ${p => p.theme.fgColorDark};
                display: inline-block;
                margin-right: 36px;
                margin-left: 4px;
            }
        }
    }

    & .bill-line-title {
        & > .bold {
            font-weight: bold;
        }
        & > .grey {
            color: ${p => p.theme.fgColorMedium};
        }
    }

    & .bill-line-total {
        display: flex;
        align-items: center;
        font-weight: 600;

        font-size: 14px;
        color: ${p => p.theme.fgColorMedium};

        > * {
            margin-left: 8px;
        }

        > *:last-child {
            color: ${p => p.theme.fgColorLight};
        }
    }

    & .bill-line-total.padded {
        padding-right: 36px;
    }

    & .bill-footer {
        font-size: 13px;
        margin-top: 30px;
        color: ${p => p.theme.fgColorMedium};

        a {
            text-decoration: underline !important;
        }
    }

    & .bill-nav {
        display: flex;
        justify-content: space-between;
    }

    & .bill-more {
        color: ${p => p.theme.iconBase};
        flex: 0 0 auto;
    }

    & svg.credit-card-icon {
        margin-right: 12px;
    }

    & .card-info-wrapper {
        display: flex;
        align-items: center;
    }

    & button.update-subscription {
        color: ${p => p.theme.linkColor};
        cursor: pointer;
    }

    & div.app-title-container {
        display: flex;
        align-items: center;

        & span.app-title {
            margin-left: 12px;
        }
    }

    & .bill-boosts-message {
        font-weight: 400;
        font-size: 13px;

        flex-grow: 1;
        align-self: flex-end;
        margin-left: 25px;
        margin-bottom: 10px;
    }

    & .bill-boosts-container {
        display: flex;
        flex-wrap: wrap;
        > * {
            margin: 0 10px 10px 0;
        }
    }

    & .billing-details-container {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        flex-wrap: row-wrap;
        > * {
            width: 550px;
        }
    }

    .tax-details-container {
        display: flex;
        flex-direction: row;
        flex-wrap: no-wrap;
        justify-content: flex-start;
        align-items: center;

        .delete-tax-wrapper {
            cursor: pointer;
            margin: auto 0 12px 8px;

            :disabled {
                cursor: default;
            }
        }
    }

    .tax-button-wrapper {
        margin: 10px 0 20px;
    }

    .save-button-wrapper {
        margin-top: 16px;
    }

    .tax-header-wrapper {
        display: flex;
        flex-direction: row;
        flex-wrap: no-wrap;
        justify-content: flex-start;
        align-items: center;
        font-weight: 600;
        font-size: 13px;
        color: ${p => p.theme.fgColorDark};

        &:not(:first-child) {
            margin-top: 16px;
        }
    }

    & .cos2-option-name {
        width: 100px;
    }

    & .cos2-name-info-wrap {
        width: 100%;
        margin-top: 10px;
        font-weight: normal;
    }

    & .cos2-input-wrap {
        margin: 8px 0;
        width: 100%;
        font-weight: normal;
    }

    & .cos2-drop-wrap {
        width: 120px;
        padding-right: 16px;
        font-weight: normal;
    }
`;

export const TransferCancelSubscriptionHeaderWrapper = styled.div`
    display: flex;
    align-items: center;

    & div.header-text {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-left: 12px;
    }
`;
